import { render, staticRenderFns } from "./GetVerifiedList.vue?vue&type=template&id=0bbd9bce&"
import script from "./GetVerifiedList.vue?vue&type=script&lang=js&"
export * from "./GetVerifiedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports